import { render, staticRenderFns } from "./RegularFront.vue?vue&type=template&id=2f5f8651&scoped=true&"
import script from "./RegularFront.vue?vue&type=script&lang=js&"
export * from "./RegularFront.vue?vue&type=script&lang=js&"
import style0 from "./RegularFront.vue?vue&type=style&index=0&id=2f5f8651&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5f8651",
  null
  
)

export default component.exports